import LoadingGate from '@components/LoadingGate/LoadingGate'
import { Pagination } from '@components/Pagination'
import { Table } from './components/Table'
import { TableRow } from './components/TableRow'
import { PaymentReportProps } from './interface'

export function PaymentReport({
  datas,
  isLoading,
  page,
  perpage,
  total,
  handlePaginationChange,
}: PaymentReportProps) {
  return (
    <div className='desktop-tablet:border-t border-gray-3 dark:border-purple desktop-tablet:px-[30px] py-[30px] mobile:py-[20px] desktop-tablet:border desktop-tablet:rounded-lg desktop-tablet:shadow'>
      <div className='text-secondary text-[24px] dark:text-dark-10 font-medium font-mitr mb-[40px] '>
        รายงานการจ่ายเงิน
      </div>

      <LoadingGate isLoading={isLoading}>
        <Table className='max-h-[785px]'>
          <Table.Row className='sticky top-0'>
            <Table.Header className='border-b border-b-gray-3 dark:border-b-purple bg-white dark:bg-dark-9 py-[10px]'>
              รอบชำระเงิน
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-b-purple bg-white dark:bg-dark-9 py-[10px]'>
              วันที่สร้างรายการ
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-b-purple bg-white dark:bg-dark-9 py-[10px]'>
              สถานะ
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-b-purple bg-white dark:bg-dark-9 py-[10px] text-right'>
              รายได้ก่อนหักภาษี ณ ที่จ่าย
              <br />
              (บาท)
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-b-purple bg-white dark:bg-dark-9 py-[10px] desktop:pl-[80px] pl-[60px]'>
              จ่ายเงินเมื่อ
            </Table.Header>
            <Table.Header className='border-b border-b-gray-3 dark:border-b-purple bg-white dark:bg-dark-9' />
          </Table.Row>

          {datas
            ? datas.map((data, index) => <TableRow key={index} data={data} />)
            : null}
        </Table>
      </LoadingGate>

      <div className='mt-[30px]'>
        <Pagination
          page={page}
          perpage={perpage}
          total={total}
          pageChange={handlePaginationChange}
        />
      </div>
    </div>
  )
}
